import React, { useContext } from 'react';
import styled from 'styled-components';
import { StrategyPerSlotContext } from '@/features/editor/widgets/custom-widget/loading-section/strategy-per-slot/context/context';
import { Footer } from '@/features/editor/widgets/shared/modals/commons';
import { CustomWidgetContext } from '@/features/editor/widgets/custom-widget/shared/context';
import {
  RecommendationOptions,
  RecommendationType,
} from '@/webapi/use-widget-catalog-api';
import { UndoRedoBtns } from '@/components/undo-redo-btns';

export function ModalFooter({ close }: { close: () => void }) {
  const ctx = useContext(StrategyPerSlotContext);
  const isUndoRedo =
    !ctx.isGlobalFilterOpen &&
    !ctx.isProductCondOpen &&
    !ctx.isManualImageSelectionOpen &&
    !ctx.isProductSearchOpen;

  const { updateRecommendationOptions } = useContext(CustomWidgetContext);
  const action = () => {
    if (ctx.isProductCondOpen) {
      ctx.setProductCondSlotOpen(undefined);
      return;
    }
    if (ctx.isGlobalFilterOpen) {
      ctx.setIsGlobalFilterOpen(false);
      ctx.saveGlobalFilter();
      return;
    }
    const options = {
      type: RecommendationType.MANUAL,
      strategyPerSlot: ctx.state?.slots,
      advancedRuling: undefined,
      condition: undefined,
      manualProducts: undefined,
      productIds: undefined,
    } as RecommendationOptions;

    updateRecommendationOptions(options);

    close();
  };
  const deleteGlobal = () => {
    ctx.setIsGlobalFilterOpen(false);
    ctx.deleteGlobalFilter();
  };

  if (ctx.isProductSearchOpen || ctx.isManualImageSelectionOpen) {
    return null;
  }

  return (
    <Wrapper>
      {isUndoRedo && (
        <UndoRedoBtns
          undo={ctx.undo}
          redo={ctx.redo}
          canUndo={ctx.canUndo}
          canRedo={ctx.canRedo}
          debounceInterval={500}
        />
      )}
      {ctx.isGlobalFilterApplied && ctx.isGlobalFilterOpen && (
        <Footer
          classNames="delete-global"
          onClick={deleteGlobal}
          bg="white"
          color="black"
          size="xl"
          text="Delete"
        />
      )}
      <Footer
        onClick={action}
        bg="black"
        size="xl"
        text={ctx.isProductCondOpen ? `Continue` : `Save`}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;

  && > div {
    margin-right: 2rem;
  }

  && > .delete-global {
    margin-right: 2rem;
    border: 2px black solid;
  }
`;
